export function getValueFromObject<T = string>(
  obj: any,
  path: string
): T | undefined {
  const els = path.split('.');

  if (!obj) return undefined;
  let result: any = obj;
  for (let i = 0; i < els.length; i++) {
    result = result[els[i]];
    if (result === undefined) return undefined;
  }

  return result as T;
}

export function setValueAtPath(obj: any, path: string, value: any): void {
  const parts = path.split('.');
  let current = obj;

  for (let i = 0; i < parts.length; i++) {
    const key = parts[i];
    const isLast = i === parts.length - 1;
    const isIndex = !isNaN(Number(key));

    if (isLast) {
      if (isIndex) {
        if (!Array.isArray(current)) current = [];
        current[Number(key)] = value;
      } else {
        current[key] = value;
      }
    } else {
      const nextKey = parts[i + 1];
      const nextIsIndex = !isNaN(Number(nextKey));

      if (isIndex) {
        const idx = Number(key);
        if (!Array.isArray(current)) current = [];
        if (!current[idx]) current[idx] = nextIsIndex ? [] : {};
        current = current[idx];
      } else {
        if (!(key in current)) current[key] = nextIsIndex ? [] : {};
        current = current[key];
      }
    }
  }
}
